import type { Components } from '@mui/material/styles';

import type { Theme } from '../theme/types';

export const MuiList = {
  styleOverrides: {
    root: { '--ListItem-gap': '16px' },
  },
} satisfies Components<Theme>['MuiList'];

export const MuiListItem = {
  styleOverrides: {
    root: { gap: 'var(--ListItem-gap)' },
  },
} satisfies Components<Theme>['MuiListItem'];

export const MuiListItemAvatar = {
  styleOverrides: {
    root: { minWidth: 'auto' },
  },
} satisfies Components<Theme>['MuiListItemAvatar'];

export const MuiListItemButton = {
  defaultProps: { disableRipple: true },
  styleOverrides: {
    root: { gap: 'var(--ListItem-gap)' },
  },
} satisfies Components<Theme>['MuiListItemButton'];

export const MuiListItemIcon = {
  styleOverrides: {
    root: {
      color: 'inherit',
      fontSize: 'var(--icon-fontSize-md)',
      minWidth: 'auto',
    },
  },
} satisfies Components<Theme>['MuiListItemIcon'];

export const MuiListItemText = {
  styleOverrides: {
    root: { margin: 0 },
  },
} satisfies Components<Theme>['MuiListItemText'];
